export default __webpack_public_path__ + "static/media/pug.e807864a.svg";